import React from 'react';

import { faSlack, faSquarespace } from "@fortawesome/free-brands-svg-icons";
import { faChevronDown, faChevronLeft, faChevronRight, faCodeCompare, faCubes, faLessThanEqual, faSearch, faShirt, faTag, faTextWidth, faWeightScale, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Autocomplete, rem, Text } from '@mantine/core';
import GroupText from '../GroupText';
import ChildrenFilter from './ChildrenFilter';
import ParentFilter from './ParentFilter';
import './SideBarLaptop.css';
import _ from 'lodash';
import { useMediaQuery } from '@mantine/hooks';

export const TargetIcon = {
    "Weight": faWeightScale,
    "Width": faTextWidth,
    "Price": faTag,
    "MOQ": faLessThanEqual,
    "Fabric Type": faSlack,
    "Fabric Content": faSquarespace,
    "Finish": faCodeCompare
}

const SideBarLaptop = (
    {
        sideBarRef, handleMenuOutsideClick, handleMenuClick, filteredSearch,
        filterClearAll, handleChipClear, filterHeader, handleOnApply, handleColorClick, setFromCollection,
        checkboxChange, selectedItems, selectedMenu, menuOpened, toggleMenu, setSelectedItems, setMenuOpened,
        handleFilterChange, group, variants, filters, allFilter, searchHandle, allCollection, checkboxChangeCollection, collectid, setCollectId, setIsSecondModalOpen
    }
) => {
    const isMobile = useMediaQuery('(max-width: 767px)');

    const isCategoryActive = (categoryName) => {
        return menuOpened && (selectedMenu?.name === categoryName || selectedMenu?.collectionName === categoryName);
    };

    return (
        <div className="absoluter" ref={sideBarRef}>
            <div className="swatchon-filters">
                <div className="bottom-overlay"></div>
                <div className="filter-panel pretty-scrollbar filter-width root g-24">
                    {(!menuOpened || (!selectedMenu?.name && !selectedMenu?.collectionName)) ? (
                        /* Main Categories List View (Image 2) */
                        <div>
                            <Autocomplete onOptionSubmit={searchHandle} data={allFilter} leftSectionPointerEvents="none" leftSection={<FontAwesomeIcon icon={faSearch} />} placeholder="Search by categories" mb={rem(6)} />
                            <div>
                                {!isMobile && Object.keys(group)
                                    .filter(groupKey => groupKey !== "COLLECTIONS").map((groupKey, index) => (
                                        <div key={index} className="sidebar-group-item">
                                            <GroupText>{groupKey}</GroupText>
                                            {group[groupKey].map((cat, subIndex) => {
                                                const isOpen = isCategoryActive(cat.name);
                                                return (
                                                    <div key={subIndex} className="sidebar-category-wrapper">
                                                        <ParentFilter
                                                            data={cat}
                                                            handleMenuClick={handleMenuClick}
                                                            selectedItems={selectedItems}
                                                            allCollection={allCollection}
                                                            setIsSecondModalOpen={true}
                                                            isExpanded={isOpen}
                                                            onToggle={() => handleMenuClick(cat)}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ))}
                                {Object.keys(group)
                                    .filter(groupKey => groupKey === "COLLECTIONS")
                                    .map((groupKey, index) => {
                                        const collectionsCat = group[groupKey];
                                        const isOpen = isCategoryActive("Collections");
                                        const collectionsCategoryObj = {
                                            name: "Collections",
                                            collectionName: "Collections",
                                            group: "COLLECTIONS",
                                            collections: collectionsCat
                                        };
                                        return (
                                            <div key={index} className="sidebar-group-item">
                                                <GroupText>{groupKey}</GroupText>
                                                <div
                                                    onClick={() => {
                                                        handleMenuClick(collectionsCategoryObj);
                                                        (isMobile && (setIsSecondModalOpen(true)));
                                                        setFromCollection(true);
                                                    }}
                                                    style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", gap: "2px", padding: "8px 4px", cursor: "pointer" }}>
                                                    <Text style={{ fontSize: "14px", color: "#000000ff" }} >
                                                        <FontAwesomeIcon icon={faCubes}
                                                            style={{ fontSize: "14px", paddingRight: "5px" }}
                                                        />Collections
                                                    </Text>
                                                    <div style={{ display: "flex", alignItems: "center" }}>
                                                        <FontAwesomeIcon icon={isOpen ? faChevronDown : faChevronRight} color="#273344" style={{ fontSize: "12px" }} />
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                    ) : (
                        /* Category Drilldown View with Back Button Header (Image 1 & Image 3) */
                        <div>
                            {(() => {
                                const activeCategoryName = selectedMenu?.name || selectedMenu?.collectionName;
                                const activeSelectedItems = selectedItems[activeCategoryName] || [];
                                const activeSelectedCount = _.size(activeSelectedItems);
                                return (
                                    <div
                                        className="sidebar-back-header"
                                        onClick={() => setMenuOpened(false)}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            fontSize: '15px',
                                            fontWeight: 700,
                                            color: '#1c2740',
                                            padding: '8px 4px',
                                            marginBottom: '10px',
                                            cursor: 'pointer',
                                            borderBottom: '1px solid #e9ecef'
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faChevronLeft} style={{ fontSize: '13px', color: '#1c2740' }} />
                                        <span>{activeCategoryName}</span>
                                        {activeSelectedCount > 0 && (
                                            <div className="badge-active-children" style={{ marginLeft: '4px' }}>
                                                {activeSelectedCount}
                                            </div>
                                        )}
                                    </div>
                                );
                            })()}
                            <ChildrenFilter
                                isInline={true}
                                selectedItems={selectedItems}
                                selectedMenu={selectedMenu}
                                collectid={collectid}
                                filterClearAll={() => {
                                    filterClearAll();
                                }}
                                setMenuOpened={setMenuOpened}
                                handleChipClear={handleChipClear}
                                setCollectId={setCollectId}
                                handleFilterChange={handleFilterChange}
                                handleOnApply={(fHeader, range, item) => {
                                    handleOnApply(selectedMenu?.name || fHeader, range, item);
                                }}
                                handleColorClick={(variant) => {
                                    handleColorClick(variant);
                                }}
                                filteredSearch={filteredSearch}
                                variants={variants}
                                checkboxChange={(event, item) => {
                                    checkboxChange(event, item);
                                }}
                                checkboxChangeCollection={checkboxChangeCollection}
                                filterHeader={selectedMenu?.name || selectedMenu?.collectionName}
                                setSelectedItems={setSelectedItems}
                                allCollection={allCollection}
                                filters={filters}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SideBarLaptop;
